import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import adminService from '../../services/adminService';
import styles from './AdminOrderDetailPage.module.scss';
import commonStyles from '../AdminOrdersPage/AdminOrdersPage.module.scss';
import { IoArrowBack } from 'react-icons/io5';

const BACKEND_URL = 'https://huongtramcomoc.vn';

const AdminOrderDetailPage = () => {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminService.getOrderDetails(id)
      .then(res => {
        setOrder(res.data);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, [id]);

  const formatPrice = (price) => new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(price);

  if (loading) return <div className={commonStyles.adminPage}><p>Đang tải...</p></div>;
  if (!order) return <div className={commonStyles.adminPage}><p>Không tìm thấy đơn hàng.</p></div>;

  return (
    <div className={commonStyles.adminPage}>
      <Link to="/admin/orders" className={styles.backButton}>
        <IoArrowBack /> Quay lại Danh sách
      </Link>
      
      <div className={styles.detailLayout}>
        {/* CỘT BÊN TRÁI: THÔNG TIN KHÁCH HÀNG */}
        <div className={styles.infoCard}>
          <h2>Thông Tin Đơn Hàng #{order.id}</h2>
          <p><strong>Khách hàng:</strong> {order.customer_name}</p>
          <p><strong>Email:</strong> {order.customer_email}</p>
          <p><strong>Số điện thoại:</strong> {order.customer_phone}</p>
          <p><strong>Địa chỉ:</strong> {order.customer_address}</p>
          <p><strong>Ghi chú:</strong> {order.notes || '(không có)'}</p>
          <hr/>
          <p><strong>Tổng tiền:</strong> <span className={styles.total}>{formatPrice(order.total_amount)}</span></p>
          <p><strong>Trạng thái:</strong> {order.status}</p>
          <p><strong>Phương thức:</strong> {order.payment_method === 'cod' ? 'Thu hộ (COD)' : 'Chuyển khoản'}</p>
        </div>
        
        {/* CỘT BÊN PHẢI: SẢN PHẨM & MINH CHỨNG */}
        <div className={styles.itemsCard}>
          <h2>Các Sản Phẩm Đã Mua</h2>
          <div className={styles.itemsList}>
            {order.items.map((item, index) => (
              <div key={index} className={styles.item}>
                <img 
                  src={item.thumbnail_url ? `${BACKEND_URL}${item.thumbnail_url}` : '/images/placeholder.jpg'} 
                  alt={item.name} 
                  className={styles.itemImage}
                />
                <div className={styles.itemInfo}>
                  <span className={styles.itemName}>{item.name}</span>
                  <span className={styles.itemQuantity}>SL: {item.quantity}</span>
                </div>
                <span className={styles.itemPrice}>{formatPrice(item.price_at_purchase * item.quantity)}</span>
              </div>
            ))}
          </div>
          
          {/* HIỂN THỊ ẢNH MINH CHỨNG (NẾU CÓ) */}
          {order.payment_proof_url && (
            <div className={styles.proofSection}>
              <h3>Minh Chứng Chuyển Khoản</h3>
              <a href={`${BACKEND_URL}${order.payment_proof_url}`} target="_blank" rel="noopener noreferrer">
                <img 
                  src={`${BACKEND_URL}${order.payment_proof_url}`} 
                  alt="Minh chứng" 
                  className={styles.proofImage}
                />
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminOrderDetailPage;